{
  "nameInput": {
    "placeholder": "Quel est votre nom ?"
  },
  "signIn": {
    "tagline": "Commencez avec intention.",
    "signingIn": "Connexion…",
    "continueApple": "Continuer avec Apple",
    "continueApple_aria": "Continuer avec Apple",
    "continueGoogle": "Continuer avec Google",
    "continueGoogle_aria": "Continuer avec Google",
    "logo_alt": "Rhemn",
    "footer": "En vous connectant, vous acceptez nos conditions d'utilisation et notre <privacyLink>Politique de confidentialité</privacyLink>.",
    "divider": "ou"
  },
  "email": {
    "identity": {
      "label": "Adresse e-mail",
      "placeholder": "you@example.com",
      "change": "Modifier",
      "change_aria": "Modifier l'adresse e-mail"
    },
    "password": {
      "label": "Mot de passe",
      "labelNew": "Choisissez un mot de passe",
      "placeholder": "Mot de passe",
      "placeholderNew": "Créez un mot de passe",
      "show": "Afficher le mot de passe",
      "hide": "Masquer le mot de passe"
    },
    "actions": {
      "continue": "Continuer",
      "signIn": "Se connecter",
      "createAccount": "Créer un compte",
      "forgot": "Mot de passe oublié ?",
      "backToSignIn": "Retour à la connexion",
      "iVerified": "J'ai vérifié mon e-mail",
      "resend": "Renvoyer le lien",
      "resendIn": "Renvoyer dans {{time}}",
      "signInInstead": "Se connecter"
    },
    "busy": {
      "checking": "Vérification…",
      "signingIn": "Connexion…",
      "creating": "Création de votre compte…",
      "sending": "Envoi…"
    },
    "switch": {
      "toCreate": "Nouveau sur Rhemn ? <switchBtn>Créer un compte</switchBtn>",
      "toSignIn": "Vous avez déjà un compte ? <switchBtn>Se connecter</switchBtn>"
    },
    "strength": {
      "tooShort": "Au moins 12 caractères.",
      "level1": "Bien. Plus long, plus sûr.",
      "level2": "Mot de passe robuste.",
      "level3": "Mot de passe très robuste."
    },
    "sent": {
      "title": "Consultez votre boîte mail",
      "body": "Nous avons envoyé un lien de réinitialisation à {{email}}. Il expire dans une heure.",
      "resent": "Renvoyé. Consultez votre boîte mail."
    },
    "verify": {
      "title": "Confirmez votre e-mail",
      "body": "Nous avons envoyé un lien à {{email}}. Ouvrez-le pour terminer la configuration de votre compte — nous prendrons le relais automatiquement.",
      "waiting": "En attente de l'ouverture du lien…",
      "resent": "Renvoyé. Consultez votre boîte mail."
    },
    "errors": {
      "invalidEmail": "Cela ne ressemble pas à une adresse e-mail.",
      "missingPassword": "Saisissez votre mot de passe.",
      "invalidCredential": "L'e-mail ou le mot de passe est incorrect.",
      "emailInUse": "Cet e-mail a déjà un compte. <signInBtn>Se connecter.</signInBtn>",
      "weakPassword": "Utilisez au moins 12 caractères.",
      "passwordTooShort": "Utilisez au moins 12 caractères.",
      "passwordCommon": "Ce mot de passe est trop facile à deviner. Essayez quelque chose de moins prévisible.",
      "emailNotVerified": "Confirmez votre e-mail avant de continuer.",
      "providerGoogle": "Cet e-mail est déjà configuré avec Google. Continuez avec Google ci-dessous.",
      "providerApple": "Cet e-mail est déjà configuré avec Apple. Continuez avec Apple ci-dessous.",
      "userDisabled": "Ce compte a été désactivé.",
      "requiresRecentLogin": "Reconnectez-vous pour effectuer cette modification.",
      "sessionExpired": "Votre session a expiré. Reconnectez-vous.",
      "expiredActionCode": "Ce lien a expiré. Demandez-en un nouveau.",
      "invalidActionCode": "Ce lien n'est plus valide. Demandez-en un nouveau.",
      "tooManyRequests": "Trop de tentatives. Attendez quelques minutes ou réinitialisez votre mot de passe.",
      "network": "Aucune connexion. Vérifiez votre réseau et réessayez.",
      "operationNotAllowed": "La connexion par e-mail n'est pas disponible pour le moment.",
      "generic": "Une erreur s'est produite. Veuillez réessayer."
    },
    "a11y": {
      "stepEmail": "Étape 1 sur 2. Saisissez votre adresse e-mail.",
      "stepPasswordSignIn": "Étape 2 sur 2. Saisissez votre mot de passe pour vous connecter.",
      "stepPasswordCreate": "Étape 2 sur 2. Choisissez un mot de passe pour votre nouveau compte.",
      "stepSent": "Lien de réinitialisation envoyé. Consultez votre boîte mail.",
      "stepVerify": "Compte créé. Lien de vérification envoyé.",
      "resendReady": "Vous pouvez renvoyer le lien maintenant."
    }
  }
}
